
const Reducer = (state: any, action: any) => {
    switch (action.type) {
        case 'SETDATA': {
            const target = action.payload;
            if (!target) {
                return state;
            }
            return {
                ...state,
                [target.name]: target.value,
            };
        }
        case 'MULTISET_STATE':
            return {
                ...state,
                ...(action.multiPayload ?? []).reduce((acc: any, { key, value }: { key: string; value: any }) => ({
                    ...acc,
                    [key]: value
                }), {})
            };
        case 'RESET':
            return action.payload;

        default: {
            return { ...state };
        }
    }
};
export default Reducer;